import { createApi } from '@reduxjs/toolkit/query/react'
import { ENDPOINTS } from '@constants/index'
import { Form } from '@typesApp/Forms'
import { Insurer, InsurerDetailArgs, InsurerDetails, InsuranceProvider, DefaultFormArgs } from '@typesApp/Insurer'
import { dbBaseQueryWithReauth } from './baseQuery'

export const insurersApi = createApi({
  reducerPath: 'insurers',
  baseQuery: dbBaseQueryWithReauth,
  keepUnusedDataFor: Number.MAX_VALUE,
  tagTypes: ['Insurers', 'InsurerDetails', 'DefaultForms', 'InsuranceProvider'],
  endpoints: builder => ({
    getInsurersPublic: builder.query<Insurer[], void>({
      query: () => `${ENDPOINTS.DIRECT_BILLING.INSURERS_PUBLIC}?active=true`,
      providesTags: [{ type: 'Insurers' }],
      transformResponse: (response: { insurers: Insurer[] }): Insurer[] => {
        return response?.insurers ?? []
      },
    }),
    getInsurerDetails: builder.query<InsurerDetails, InsurerDetailArgs>({
      query: args => ENDPOINTS.DIRECT_BILLING.INSURER_DETAILS.replace('{{insurerId}}', args.insurerId),
      providesTags: [{ type: 'InsurerDetails' }],
    }),
    getDefaultForms: builder.query<Form[], DefaultFormArgs>({
      query: args =>
        ENDPOINTS.DIRECT_BILLING.INSURANCE_PROVIDER_DEFAULT_FORMS.replace(
          '{{insuranceProviderId}}',
          args.insuranceProviderId
        ),
      providesTags: [{ type: 'DefaultForms' }],
      transformResponse: (response: { formGroups: Form[] }) => response.formGroups,
    }),
    getInsuranceProvider: builder.query<InsuranceProvider, DefaultFormArgs>({
      query: args =>
        ENDPOINTS.DIRECT_BILLING.INSURANCE_PROVIDER.replace('{{insuranceProviderId}}', args.insuranceProviderId),
      providesTags: [{ type: 'InsuranceProvider' }],
    }),
  }),
})

export const {
  useGetInsurersPublicQuery,
  useGetInsurerDetailsQuery,
  useGetDefaultFormsQuery,
  useGetInsuranceProviderQuery,
  useLazyGetInsuranceProviderQuery,
  useLazyGetInsurerDetailsQuery,
  useLazyGetDefaultFormsQuery,
} = insurersApi
